import { useEffect, useRef } from 'react';

/**
 * Hook para detectar mudanças não salvas e exibir aviso ao sair da página
 * @param {boolean} hasUnsavedChanges - Se há mudanças não salvas
 * @param {string} warningMessage - Mensagem a ser exibida no aviso
 */
export const useUnsavedChanges = (
    hasUnsavedChanges = false, 
    warningMessage = "Você tem alterações não salvas no diagrama. Tem certeza que deseja sair sem fazer o download das últimas alterações?"
) => {
    const warningMessageRef = useRef(warningMessage);
    
    // Atualiza a mensagem quando ela muda
    useEffect(() => {
        warningMessageRef.current = warningMessage;
    }, [warningMessage]);

    useEffect(() => {
        // Função para lidar com o evento beforeunload (F5, fechar aba, etc)
        const handleBeforeUnload = (e) => {
            if (hasUnsavedChanges) {
                // Para navegadores modernos, a mensagem customizada pode não ser exibida
                // mas o evento ainda previne o fechamento até confirmação
                e.preventDefault();
                e.returnValue = warningMessageRef.current;
                return warningMessageRef.current;
            }
        };

        // Função para lidar com mudanças na rota (navegação interna) - REMOVIDA
        // O evento popstate não é necessário para este caso específico
        // pois a aplicação é uma SPA (Single Page Application)

        // Adiciona o event listener
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup: remove o event listener
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [hasUnsavedChanges]);

    // Função para ser chamada quando o usuário salva as alterações
    const markAsSaved = () => {
        // Esta função pode ser chamada pelo componente pai quando o download é feito
        // O estado hasUnsavedChanges deve ser atualizado no componente pai
    };

    return { markAsSaved };
};
